module.exports = __webpack_public_path__ + "static/media/google-icon.f5ee518a.svg";